const NOTIFICATION_SOUND_PATH = '/include/sounds/notification-sound.mp3';
export const playNotificationSound = () => {
    const audio = new Audio(NOTIFICATION_SOUND_PATH);
    audio.volume = 1;
    audio.play();
};

type Window = {
    location?: {
        pathname?: string;
    };
};

export function shouldClientRoute(to?: string, window?: Window | null): boolean {
    if (!to) {
        return false;
    }

    if (window && window.location && window.location.pathname) {
        return !window.location.pathname.includes(to);
    }

    return false;
}
